import { styled } from '@abyss/web/tools/styled';

export const WidgetDisclaimersWrapper = styled('div', {
  display: 'inline-block',
});
